module.exports = __webpack_public_path__ + "img/android-main.c36ddeb0.webp";